import api from './api';

export interface TaskType {
  id: number;
  name: string;
  enabled: boolean;
  created_by?: number;
  updated_by?: number;
  created_at: string;
  updated_at: string;
}

export interface CreateTaskTypeData {
  name: string;
  enabled?: boolean;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const taskTypeService = {
  async getAll() {
    const response = await api.get('/task-types');
    return response.data;
  },

  async create(data: CreateTaskTypeData): Promise<TaskType> {
    const response = await api.post('/task-types', data);
    return unwrap<TaskType>(response);
  },

  async update(id: number, data: Partial<CreateTaskTypeData>): Promise<TaskType> {
    const response = await api.put(`/task-types/${id}`, data);
    return unwrap<TaskType>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/task-types/${id}`);
  },
};

